var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tab-limit"},[_c('div',{class:_vm.tab.classList},[_vm._v(" "+_vm._s(_vm.tab.content)+" ")]),_c('button',{staticClass:"tab-limit-button",on:{"click":_vm.navigateToSuiteSettings}},[_c('v-icon',[_vm._v("pencil")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }